import { createDrift, } from "@delvtech/drift";
import { v4MigratorAbi } from "../../abis";
export class ReadMigrator {
    constructor(address, drift = createDrift()) {
        this.migrator = drift.contract({
            abi: v4MigratorAbi,
            address,
        });
    }
    async getAssetData(token0, token1, options) {
        return this.migrator.read("getAssetData", {
            token0,
            token1,
            ...options,
        });
    }
    async airlock() {
        return this.migrator.read("airlock");
    }
    async locker() {
        return this.migrator.read("locker");
    }
    async poolManager() {
        return this.migrator.read("poolManager");
    }
    async positionManager() {
        return this.migrator.read("positionManager");
    }
    async DEAD_ADDRESS() {
        return this.migrator.read("DEAD_ADDRESS");
    }
}
//# sourceMappingURL=ReadMigrator.js.map